module.exports = __webpack_public_path__ + "static/freedom-e329bc9a7517ad51481e892c8c57e546.png";